// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Inbox Page Styles */
.inbox-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.inbox-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 100px 20px 40px;
}

.inbox-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e2e8f0;
}

.inbox-title-section {
  flex: 1 1;
}

.inbox-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.inbox-icon {
  font-size: 2.5rem;
}

.inbox-subtitle {
  color: #64748b;
  margin-top: 8px;
  font-size: 1rem;
}

.inbox-stats {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.inbox-count {
  color: #475569;
  font-weight: 500;
}

.inbox-unread {
  color: #22c55e;
  font-weight: 600;
  font-size: 0.9rem;
}

/* Error State */
.inbox-error {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 12px;
  color: #dc2626;
  margin-bottom: 20px;
}

.error-icon {
  font-size: 1.5rem;
}

/* Empty State */
.inbox-empty {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.inbox-empty-icon {
  font-size: 5rem;
  margin-bottom: 20px;
}

.inbox-empty h2 {
  font-size: 1.5rem;
  color: #1e293b;
  margin-bottom: 8px;
}

.inbox-empty p {
  color: #64748b;
}

/* Message List */
.inbox-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.inbox-item {
  display: flex;
  align-items: stretch;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  text-decoration: none;
  transition: all 0.2s ease;
  border: 1px solid #e2e8f0;
}

.inbox-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  border-color: #22c55e;
}

.inbox-item.unread {
  background: linear-gradient(to right, #f0fdf4, white);
  border-left: 4px solid #22c55e;
}

.inbox-item-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  padding: 0 8px;
}

.unread-dot {
  width: 10px;
  height: 10px;
  background: #22c55e;
  border-radius: 50%;
  box-shadow: 0 0 8px rgba(34, 197, 94, 0.4);
}

.inbox-item-content {
  flex: 1 1;
  padding: 16px;
  min-width: 0;
}

.inbox-item-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 8px;
}

.inbox-item-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.inbox-item.unread .inbox-item-title {
  font-weight: 700;
}

.inbox-item-date {
  font-size: 0.85rem;
  color: #94a3b8;
  white-space: nowrap;
}

.inbox-item-description {
  color: #64748b;
  font-size: 0.95rem;
  line-height: 1.5;
  margin-bottom: 12px;
  white-space: pre-wrap;
  word-break: break-word;
}

.inbox-item-footer {
  display: flex;
  align-items: center;
  gap: 16px;
}

.inbox-item-sender {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: #475569;
}

.sender-icon {
  font-size: 0.9rem;
}

.inbox-item-pdf {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.8rem;
  color: #ef4444;
  background: #fef2f2;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 500;
}

.pdf-icon {
  font-size: 0.85rem;
}

.inbox-item-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  background: #f8fafc;
  border-left: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.inbox-item:hover .inbox-item-action {
  background: #22c55e;
}

.open-icon {
  font-size: 1.2rem;
  color: #94a3b8;
  transition: all 0.2s ease;
}

.inbox-item:hover .open-icon {
  color: white;
  transform: translateX(2px);
}

/* Responsive */
@media (max-width: 640px) {
  .inbox-container {
    padding: 80px 16px 30px;
  }

  .inbox-header {
    flex-direction: column;
    gap: 16px;
  }

  .inbox-stats {
    flex-direction: row;
    gap: 16px;
  }

  .inbox-title {
    font-size: 1.5rem;
  }

  .inbox-item-header {
    flex-direction: column;
    gap: 4px;
  }

  .inbox-item-indicator {
    width: 30px;
  }

  .inbox-item-action {
    width: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/InboxPage.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Inbox Page Styles */\n.inbox-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n}\n\n.inbox-container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 100px 20px 40px;\n}\n\n.inbox-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.inbox-title-section {\n  flex: 1;\n}\n\n.inbox-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0;\n}\n\n.inbox-icon {\n  font-size: 2.5rem;\n}\n\n.inbox-subtitle {\n  color: #64748b;\n  margin-top: 8px;\n  font-size: 1rem;\n}\n\n.inbox-stats {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n}\n\n.inbox-count {\n  color: #475569;\n  font-weight: 500;\n}\n\n.inbox-unread {\n  color: #22c55e;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n/* Error State */\n.inbox-error {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 12px;\n  color: #dc2626;\n  margin-bottom: 20px;\n}\n\n.error-icon {\n  font-size: 1.5rem;\n}\n\n/* Empty State */\n.inbox-empty {\n  text-align: center;\n  padding: 60px 20px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.inbox-empty-icon {\n  font-size: 5rem;\n  margin-bottom: 20px;\n}\n\n.inbox-empty h2 {\n  font-size: 1.5rem;\n  color: #1e293b;\n  margin-bottom: 8px;\n}\n\n.inbox-empty p {\n  color: #64748b;\n}\n\n/* Message List */\n.inbox-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.inbox-item {\n  display: flex;\n  align-items: stretch;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  border: 1px solid #e2e8f0;\n}\n\n.inbox-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n  border-color: #22c55e;\n}\n\n.inbox-item.unread {\n  background: linear-gradient(to right, #f0fdf4, white);\n  border-left: 4px solid #22c55e;\n}\n\n.inbox-item-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  padding: 0 8px;\n}\n\n.unread-dot {\n  width: 10px;\n  height: 10px;\n  background: #22c55e;\n  border-radius: 50%;\n  box-shadow: 0 0 8px rgba(34, 197, 94, 0.4);\n}\n\n.inbox-item-content {\n  flex: 1;\n  padding: 16px;\n  min-width: 0;\n}\n\n.inbox-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.inbox-item-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.inbox-item.unread .inbox-item-title {\n  font-weight: 700;\n}\n\n.inbox-item-date {\n  font-size: 0.85rem;\n  color: #94a3b8;\n  white-space: nowrap;\n}\n\n.inbox-item-description {\n  color: #64748b;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  margin-bottom: 12px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.inbox-item-footer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.inbox-item-sender {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.85rem;\n  color: #475569;\n}\n\n.sender-icon {\n  font-size: 0.9rem;\n}\n\n.inbox-item-pdf {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.8rem;\n  color: #ef4444;\n  background: #fef2f2;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-weight: 500;\n}\n\n.pdf-icon {\n  font-size: 0.85rem;\n}\n\n.inbox-item-action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50px;\n  background: #f8fafc;\n  border-left: 1px solid #e2e8f0;\n  transition: all 0.2s ease;\n}\n\n.inbox-item:hover .inbox-item-action {\n  background: #22c55e;\n}\n\n.open-icon {\n  font-size: 1.2rem;\n  color: #94a3b8;\n  transition: all 0.2s ease;\n}\n\n.inbox-item:hover .open-icon {\n  color: white;\n  transform: translateX(2px);\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .inbox-container {\n    padding: 80px 16px 30px;\n  }\n\n  .inbox-header {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .inbox-stats {\n    flex-direction: row;\n    gap: 16px;\n  }\n\n  .inbox-title {\n    font-size: 1.5rem;\n  }\n\n  .inbox-item-header {\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .inbox-item-indicator {\n    width: 30px;\n  }\n\n  .inbox-item-action {\n    width: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
